import { Component, Input, OnChanges } from '@angular/core';
import {
  ButtonContent,
  MasterJson,
} from 'src/app/modules/templates/interfaces/create-template.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-html-preview',
  templateUrl: './html-preview.component.html',
  styleUrls: ['./html-preview.component.scss'],
})
export class HtmlPreviewComponent implements OnChanges {
  @Input() emailHtmlContent: string;
  @Input() templateData: {
    subject?: string;
    templateJson?: MasterJson;
    senderId?: string;
  };
  @Input() activeMode: string;

  currentTime = new Date();

  ngOnChanges(): void {
    if (!this.emailHtmlContent) {
      return;
    }

    const templateJson = this.templateData.templateJson;
    const hasFormData = !!(templateJson?.formCode && templateJson?.formName);
    const { placeholderReplacements, isFormInButton } =
      this.collectButtonMetadata(templateJson, hasFormData);

    const buttonPlaceholderRegex = /#button_tiny\d+#/g;
    this.emailHtmlContent = this.emailHtmlContent.replaceAll(
      buttonPlaceholderRegex,
      (match) => placeholderReplacements.get(match) || match
    );

    if (hasFormData) {
      const { formCode, formName } = templateJson;
      const formUrl = `${environment.FORM_PREVIEW_URL}/form/${formCode}/PREVIEW`;
      const updatedFormUrl = `${formName} (${formCode})`;
      const replacementValue = isFormInButton
        ? formUrl
        : `<a href="${formUrl}" target="_blank">${updatedFormUrl}</a>`;

      this.emailHtmlContent = this.emailHtmlContent
        .replaceAll('#form_url#', replacementValue)
        .replaceAll('#form_url_tiny#', replacementValue);
    }
  }

  private collectButtonMetadata(
    templateJson: MasterJson | undefined,
    hasFormData: boolean
  ): {
    placeholderReplacements: Map<string, string>;
    isFormInButton: boolean;
  } {
    const placeholderReplacements = new Map<string, string>();
    let isFormInButton = false;

    const rows = templateJson?.layout?.rows;
    if (!rows) {
      return { placeholderReplacements, isFormInButton };
    }

    const buttonColumns = rows
      .flatMap((row) => row.columns)
      .filter((column) => column?.content?.type === 'BUTTON');

    for (const column of buttonColumns) {
      const buttonContent = column.content.properties as ButtonContent;

      if (hasFormData && buttonContent.selectedWebForm) {
        isFormInButton = true;
      }

      if (!buttonContent.selectedWebForm && buttonContent.paramPlaceholder) {
        const placeholder = `${buttonContent.paramPlaceholder}`;
        const actionUrl = buttonContent.actionUrl;
        if (actionUrl) {
          placeholderReplacements.set(placeholder, actionUrl);
        }
      }
    }

    return { placeholderReplacements, isFormInButton };
  }
}
